import styled, { css } from 'styled-components';
export const StyledFileList = styled.ul `
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  padding: 0 10px;
  margin: 0;
  min-height: 50px;
`;
export const FileItem = styled.li `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #ddd;
  position: relative;
  z-index: 20;
`;
export const DeleteButton = styled.button `
  border-radius: 50%;
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 24px;
  height: 25px;
  ${({ theme }) => css `
    background-color: ${theme.palette.white.main};

    &:hover {
      background-color: ${theme.palette.white.main};
    }

    color: ${theme.palette.primary.main};
    border: 1px solid ${theme.palette.primary.main};
  `}
`;
export const FilePreview = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
  min-width: 50px;
  min-height: 50px;
`;
export const FileIcon = styled.img `
  width: 50px;
  height: 50px;
  object-fit: contain;
`;
